import { useSettingStore } from "@/stores/settingStore";

export const getContrastTextFromHex = (hexcolor) => {
    if (!hexcolor) {
        return 'black';
    } else {
        const r = parseInt(hexcolor.substring(1, 3), 16);
        const g = parseInt(hexcolor.substring(3, 5), 16);
        const b = parseInt(hexcolor.substring(5, 7), 16);
        const contrastColor = ((r * 299) + (g * 587) + (b * 114)) / 1000;
        return (contrastColor >= 128) ? 'black' : 'white';
    }
}

export const getSeverity = (thresholdType, severity) => {
    const settingStore = useSettingStore();
    const myLevel = settingStore[thresholdType].find(level => level.riskLevel === severity);
    return myLevel;
}

export const getRiskClass = (severity) => {
    const color = getSeverity('forecastLevels', severity)?.color;
    if (color === '#00ab8a') return 'green-6';
    if (color === '#83d295') return 'green-2';
    if (color === '#ffe13b') return 'yellow-3';
    if (color === '#ffba04') return 'amber-8';
    if (color === '#fe8231') return 'orange-7';
    if (color === '#d71808') return 'red-13';
    return '';
}
